(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-bundle"] && !Shopify.designMode) return;
  try {
    
  /*
   * Scoped per instance. This used to grab `querySelector('[data-bndl]')` — the
   * FIRST builder on the page — so a second one anywhere would render but be
   * completely dead, with no error to point at it.
   */
  document.querySelectorAll('[data-bndl]').forEach(function (root) {
    const slotCount = parseInt(root.dataset.slots, 10) || 3;
    const slotEls = [...root.querySelectorAll('[data-bndl-slot]')];
    const countEl = root.querySelector('[data-bndl-count]');
    const totalEl = root.querySelector('[data-bndl-total]');
    const cta = root.querySelector('[data-bndl-submit]');
    const ctaLabel = root.querySelector('[data-bndl-cta-label]');

    /* chosen[i] = {id, name, price} | null */
    const chosen = new Array(slotCount).fill(null);

    /*
     * Currency affixes come from Liquid rather than a hardcoded '$', so a store in
     * another currency does not silently label its totals in dollars.
     */
    const pre = root.dataset.moneyPre || '';
    const post = root.dataset.moneyPost || '';
    const money = (cents) => pre + (cents / 100).toFixed(2) + post;

    function render() {
      let filled = 0;
      let total = 0;

      slotEls.forEach((el, i) => {
        const pick = chosen[i];
        const nameEl = el.querySelector('[data-bndl-slot-name]');
        const clear = el.querySelector('[data-bndl-clear]');
        if (pick) {
          filled += 1;
          total += pick.price;
          nameEl.textContent = pick.name;
          el.classList.add('is-filled');
          clear.hidden = false;
        } else {
          nameEl.textContent = '';
          el.classList.remove('is-filled');
          clear.hidden = true;
        }
      });

      countEl.textContent = filled;
      totalEl.textContent = money(total);

      const remaining = slotCount - filled;
      cta.disabled = remaining !== 0;
      ctaLabel.textContent = remaining === 0
        ? 'Add bundle to cart'
        : 'Select ' + remaining + ' more flavour' + (remaining === 1 ? '' : 's');
    }

    root.addEventListener('click', (e) => {
      const add = e.target.closest('[data-bndl-add]');
      if (add) {
        const free = chosen.indexOf(null);
        if (free === -1) return; /* full — ignore rather than silently replace */
        chosen[free] = {
          id: add.dataset.id,
          name: add.dataset.name,
          price: parseInt(add.dataset.price, 10) || 0
        };
        render();
        return;
      }

      const clear = e.target.closest('[data-bndl-clear]');
      if (clear) {
        const slot = clear.closest('[data-bndl-slot]');
        chosen[parseInt(slot.dataset.bndlSlot, 10)] = null;
        render();
      }
    });

    cta.addEventListener('click', async () => {
      /* Collapse duplicate flavours into one line with a quantity. */
      const byId = new Map();
      chosen.forEach((c) => {
        if (!c) return;
        byId.set(c.id, (byId.get(c.id) || 0) + 1);
      });
      const planEl = root.querySelector('[data-bndl-plan]');
      const planId = planEl && planEl.value ? Number(planEl.value) : null;
      const items = [...byId.entries()].map(([id, quantity]) => {
        const line = { id: Number(id), quantity };
        if (planId) line.selling_plan = planId;
        return line;
      });
      if (!items.length) return;

      const original = ctaLabel.textContent;
      cta.disabled = true;
      ctaLabel.textContent = 'Adding…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) throw new Error('cart');
        window.location.href = '/cart';
      } catch (err) {
        ctaLabel.textContent = 'Could not add — try again';
        cta.disabled = false;
        setTimeout(() => { ctaLabel.textContent = original; }, 2500);
      }
    });

    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-formula-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-fmap-dot]').forEach((dot) => {
      dot.addEventListener('click', () => {
        const root = dot.closest('.fmap');
        if (!root) return;
        const index = dot.dataset.fmapDot;
        root.querySelectorAll('[data-fmap-dot]').forEach((d) => {
          const on = d === dot;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-fmap-panel]').forEach((p) => {
          p.hidden = p.dataset.fmapPanel !== index;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-bfp]');
    if (!root) return;

    const readJSON = (sel) => {
      const el = root.querySelector(sel);
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    };

    const variants = readJSON('[data-bfp-variants]') || [];
    const cfg = readJSON('[data-bfp-config]') || {};

    /* ---------- gallery ---------- */
    const stage = root.querySelector('[data-bfp-stage]');
    root.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-bfp-thumb]');
      if (!thumb || !stage) return;
      stage.src = thumb.dataset.bfpThumb;
      /* Injected sources must load eagerly — lazy leaves the stage blank. */
      stage.loading = 'eager';
      root.querySelectorAll('[data-bfp-thumb]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });

    const zoom = root.querySelector('[data-bfp-zoom]');
    if (zoom && stage) {
      zoom.addEventListener('click', () => root.classList.toggle('is-zoomed'));
    }

    /*
     * Token patterns are built with `new RegExp` from escaped strings so no
     * literal double-brace ever appears in this file. A bare one inside a Liquid
     * string makes `shopify theme push` report success and then silently skip
     * the whole file.
     */
    const AMT = new RegExp('\\{\\{\\s*amount\\s*\\}\\}');
    const AMT_ND = new RegExp('\\{\\{\\s*amount_no_decimals\\s*\\}\\}');
    const fmt = (cents) => {
      /* Whole-dollar amounts print without the ".00" — $48, not $48.00 —
         matching the Liquid money_without_trailing_zeros paint. Real cents
         keep their two decimals. */
      const amount = cents % 100 === 0
        ? String(cents / 100)
        : (cents / 100).toFixed(2);
      const f = cfg.moneyFormat || '';
      if (AMT.test(f)) return f.replace(AMT, amount);
      if (AMT_ND.test(f)) return f.replace(AMT_ND, Math.round(cents / 100));
      return '$' + amount;
    };

    const packEls = [...root.querySelectorAll('[data-bfp-pack]')];
    const planTabs = [...root.querySelectorAll('[data-bfp-plan-tab]')];
    const flavourEls = [...root.querySelectorAll('[data-bfp-flavour]')];
    const subTab = planTabs.find((el) => el.dataset.bfpPlanTab === 'sub');
    const onceTab = planTabs.find((el) => el.dataset.bfpPlanTab === 'once');
    const subRadio = subTab ? subTab.querySelector('input[name="selling_plan"]') : null;

    const currentPack = () => {
      const sel = packEls.find((el) => el.classList.contains('is-selected'));
      return sel ? sel.dataset.bfpPack : null;
    };

    const findVariant = (pack, flavour) =>
      variants.find((v) => {
        if (cfg.packIndex !== null && pack !== null && v.options[cfg.packIndex] !== pack) return false;
        if (cfg.flavorIndex !== null && flavour !== null && v.options[cfg.flavorIndex] !== flavour) return false;
        return true;
      });

    const qtyOf = (el) => parseInt(el.querySelector('[data-bfp-count]').textContent, 10) || 0;
    const totalQty = () => flavourEls.reduce((n, el) => n + qtyOf(el), 0);

    const subSelected = () => !!subTab && subTab.classList.contains('is-selected');

    /*
     * The plan that applies to THIS variant. Plans are scoped per variant —
     * monthly on the 30-pack, quarterly on the crew pack — so the chosen plan
     * id is only kept when the variant actually carries it; otherwise the
     * variant's own first plan wins and the radio is rewritten to match.
     */
    const allocFor = (v) => {
      const plans = v.plans || [];
      if (!plans.length) return null;
      const chosen = subRadio
        ? plans.find((pl) => String(pl.id) === String(subRadio.value))
        : null;
      return chosen || plans[0];
    };

    const selectOne = (list, el) => {
      list.forEach((x) => x.classList.remove('is-selected'));
      el.classList.add('is-selected');
      const input = el.querySelector('input');
      if (input) input.checked = true;
    };

    function render() {
      const pack = currentPack();
      /* Price the pack off any variant in it — flavour never changes price. */
      const base = findVariant(pack, null) || variants[0];
      if (!base) return;

      const plans = base.plans || [];

      /* A variant with no plan of its own cannot be subscribed to. */
      if (subTab) subTab.classList.toggle('is-disabled', plans.length === 0);
      if (subSelected() && plans.length === 0 && onceTab) selectOne(planTabs, onceTab);
      const subMode = subSelected() && plans.length > 0;

      const al = subMode ? allocFor(base) : null;
      if (al && subRadio) subRadio.value = al.id;

      const lines = flavourEls.length ? Math.max(totalQty(), 1) : 1;
      const unit = al ? al.price : base.price;
      const now = unit * lines;

      /* Struck figure: on subscription it is the one-time price this plan
         undercuts; buying once it is the compare-at, when one exists. */
      let was = 0;
      if (al) {
        if (base.price > al.price) was = base.price * lines;
      } else if (base.compare) {
        was = base.compare * lines;
      }

      root.querySelector('[data-bfp-now]').textContent = fmt(now);

      const wasEl = root.querySelector('[data-bfp-was]');
      const savedEl = root.querySelector('[data-bfp-saved]');
      if (was > now) {
        wasEl.textContent = fmt(was);
        wasEl.hidden = false;
        savedEl.textContent = 'Save ' + fmt(was - now);
        savedEl.hidden = false;
      } else {
        /* Always in the DOM and toggled, so a variant with no saving cannot
           leave the previous variant's figure stranded on screen. */
        wasEl.hidden = true;
        savedEl.hidden = true;
      }

      /* The tab badge follows the selected pack's own saving, whatever mode
         is active — it advertises what subscribing would save on this pack. */
      const segSave = root.querySelector('[data-bfp-seg-save]');
      if (segSave) {
        const would = plans.length ? plans[0] : null;
        const saving = would ? base.price - would.price : 0;
        if (saving > 0) {
          segSave.textContent = 'Save ' + fmt(saving);
          segSave.hidden = false;
        } else {
          segSave.hidden = true;
        }
      }

      /* Every pack tile re-prices with the mode, each off its own plan. */
      packEls.forEach((el) => {
        const priceEl = el.querySelector('[data-bfp-pack-price]');
        if (!priceEl) return;
        const v = findVariant(el.dataset.bfpPack, null);
        if (!v) return;
        let tile = v.price;
        if (subMode && v.plans && v.plans.length) {
          tile = v.id === base.id ? unit : v.plans[0].price;
        }
        priceEl.textContent = fmt(tile);
      });

      /* Frequency dropdown lists the selected variant's own plans only. */
      const freq = root.querySelector('[data-bfp-frequency]');
      if (freq) {
        if (subMode && plans.length > 1) {
          freq.textContent = '';
          plans.forEach((pl) => {
            const o = document.createElement('option');
            o.value = pl.id;
            o.textContent = pl.name;
            freq.appendChild(o);
          });
          if (al) freq.value = String(al.id);
          freq.hidden = false;
        } else {
          freq.hidden = true;
        }
      }

      /* The one-time line always quotes the full price for this pack. */
      const otp = root.querySelector('[data-bfp-onetime-price]');
      if (otp) otp.textContent = '— ' + fmt(base.price * lines);

      /* Chips and the gift box are scoped to the purchase mode: the Starter
         Kit and pause-any-time belong to the subscription only. */
      root.querySelectorAll('[data-bfp-perk-show]').forEach((el) => {
        const scope = el.dataset.bfpPerkShow || 'both';
        el.hidden = !(scope === 'both' || scope === (subMode ? 'sub' : 'once'));
      });
      const giftsBox = root.querySelector('[data-bfp-gifts]');
      if (giftsBox) giftsBox.hidden = !subMode;

      /* The panel label names what is actually about to be bought. */
      const planLabel = root.querySelector('[data-bfp-price-plan]');
      if (planLabel) {
        planLabel.textContent = subMode
          ? (planLabel.dataset.subLabel || 'Subscription')
          : 'One-time';
      }

      root.querySelector('[data-bfp-atc-price]').textContent = '· ' + fmt(now);
      root.querySelector('[data-bfp-id]').value = base.id;

      const atc = root.querySelector('[data-bfp-atc]');
      const label = root.querySelector('[data-bfp-atc-label]');
      const note = root.querySelector('[data-bfp-note]');

      if (!base.available) {
        /* Say sold out rather than offering a disabled "Add to cart", which
           reads as a broken button. */
        atc.disabled = true;
        label.textContent = 'Sold out';
        if (note) note.hidden = true;
      } else if (flavourEls.length && totalQty() === 0) {
        atc.disabled = true;
        label.textContent = 'Add to Cart';
        if (note) { note.textContent = 'Pick at least one flavour'; note.hidden = false; }
      } else {
        atc.disabled = false;
        label.textContent = 'Add to Cart';
        if (note) note.hidden = true;
      }
    }

    packEls.forEach((el) => el.addEventListener('click', () => { selectOne(packEls, el); render(); }));
    planTabs.forEach((el) => el.addEventListener('click', () => { selectOne(planTabs, el); render(); }));

    /* The one-time line drives the same radios the segmented control does, so the
       two can never disagree about what is about to be added to the cart. */
    const oneTime = root.querySelector('[data-bfp-onetime]');
    if (oneTime && onceTab) {
      oneTime.addEventListener('click', () => { selectOne(planTabs, onceTab); render(); });
    }

    root.querySelectorAll('[data-bfp-inc], [data-bfp-dec]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const li = btn.closest('[data-bfp-flavour]');
        const out = li.querySelector('[data-bfp-count]');
        const step = btn.hasAttribute('data-bfp-inc') ? 1 : -1;
        out.textContent = Math.max(0, (parseInt(out.textContent, 10) || 0) + step);
        render();
      });
    });

    /* Frequency select drives the submitted selling plan, then re-prices —
       different plans can carry different prices. */
    const freqEl = root.querySelector('[data-bfp-frequency]');
    if (freqEl) {
      freqEl.addEventListener('change', () => {
        if (subRadio && subSelected()) subRadio.value = freqEl.value;
        render();
      });
    }

    /* ---------- multi-line add to cart ---------- */
    const form = root.querySelector('[data-bfp-form]');
    form.addEventListener('submit', async (e) => {
      if (!flavourEls.length) return; /* single line: post normally */
      e.preventDefault();

      const pack = currentPack();
      const planEl = root.querySelector('input[name="selling_plan"]:checked');
      const plan = planEl && planEl.value ? planEl.value : null;

      const items = [];
      flavourEls.forEach((li) => {
        const q = qtyOf(li);
        if (!q) return;
        const v = findVariant(pack, li.dataset.bfpFlavour);
        if (!v) return;
        const line = { id: v.id, quantity: q };
        if (plan) line.selling_plan = plan;
        items.push(line);
      });
      if (!items.length) return;

      const atc = root.querySelector('[data-bfp-atc]');
      const label = root.querySelector('[data-bfp-atc-label]');
      const original = label.textContent;
      atc.disabled = true;
      label.textContent = 'Adding…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!res.ok) throw new Error('cart');
        window.location.href = '/cart';
      } catch (err) {
        label.textContent = 'Could not add — try again';
        atc.disabled = false;
        setTimeout(() => { label.textContent = original; }, 2500);
      }
    });

    render();
  })();
/* ---------- buy-box review carousel ---------- */
(() => {
  document.querySelectorAll('[data-bfp-revs]').forEach((root) => {
    const track = root.querySelector('[data-bfp-revs-track]');
    const slides = track ? Array.from(track.children) : [];
    if (slides.length < 2) return;
    const dots = Array.from(root.querySelectorAll('[data-bfp-revs-dot]'));
    let idx = 0;
    let timer = null;
    const paint = () => dots.forEach((d, j) => d.classList.toggle('is-on', j === idx));
    const go = (i) => {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' });
      paint();
    };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const start = () => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      timer = setInterval(() => go(idx + 1), 5000);
    };
    dots.forEach((d, i) => d.addEventListener('click', () => { go(i); start(); }));
    /* Manual swipes move the track without go(), so resync the dots. */
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== idx) { idx = i; paint(); }
    }, { passive: true });
    ['pointerenter', 'touchstart', 'focusin'].forEach((ev) => root.addEventListener(ev, stop, { passive: true }));
    ['pointerleave', 'focusout'].forEach((ev) => root.addEventListener(ev, start));
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-review-wall"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-rvw-more]').forEach((btn) => {
  btn.addEventListener('click', () => {
    const wall = btn.closest('.rvw')?.querySelector('[data-rvw-wall]');
    if (wall) wall.classList.remove('is-collapsed');
    btn.setAttribute('aria-expanded', 'true');
    btn.parentElement.remove();
  });
});

  } catch(e) { console.error(e); }
})();
})();
